"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _NavMarker = _interopRequireDefault(require("react-rhumb/NavMarker"));

var _reactRedux = require("react-redux");

var _reselect = require("reselect");

var _immutable = _interopRequireDefault(require("immutable"));

var _I18n = _interopRequireDefault(require("I18n"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _unescapedText = _interopRequireDefault(require("I18n/utils/unescapedText"));

var _UIRouterLink = _interopRequireDefault(require("ui-addon-react-router-dom/UIRouterLink"));

var StorefrontActions = _interopRequireWildcard(require("../../actions/StorefrontActions"));

var _HrefLangLink = _interopRequireDefault(require("ecosystem-marketplace-core/components/elements/HrefLangLink"));

var _OpenGraphMeta = _interopRequireDefault(require("ecosystem-marketplace-core/components/elements/OpenGraphMeta"));

var _TwitterMeta = _interopRequireDefault(require("ecosystem-marketplace-core/components/elements/TwitterMeta"));

var _DocumentHead = _interopRequireDefault(require("ecosystem-marketplace-core/components/portals/DocumentHead"));

var _PrerenderReady = _interopRequireDefault(require("ecosystem-marketplace-core/components/prerender/PrerenderReady"));

var _RequestState = require("ecosystem-marketplace-core/constants/RequestState");

var _userAgent = require("ecosystem-marketplace-core/utils/userAgent");

var StorefrontCollection = _interopRequireWildcard(require("../../constants/StorefrontCollection"));

var _storefrontCollectionOrder = _interopRequireDefault(require("../../constants/storefrontCollectionOrder"));

var _auth = require("../../selectors/auth");

var _history = require("../../utils/history");

var _useMounted = require("../../utils/hooks/useMounted");

var _useVisible = require("../../utils/hooks/useVisible");

var _i18n = require("../../utils/i18n");

var _requestState = require("../../utils/requestState");

var _urls = require("../../utils/urls");

var _StorefrontSectionMarkerContext = _interopRequireDefault(require("../../context/StorefrontSectionMarkerContext"));

var _StorefrontUsageTrackerContext = _interopRequireDefault(require("../../context/StorefrontUsageTrackerContext"));

var _CanonicalLink = _interopRequireDefault(require("../../components/elements/CanonicalLink"));

var _GenericError = _interopRequireDefault(require("../../components/error/GenericError"));

var _ResultsGrid = _interopRequireDefault(require("../../components/storefront/results/ResultsGrid"));

var _ResultsSection = _interopRequireDefault(require("../../components/storefront/results/ResultsSection"));

var _ResultsSectionHeader = _interopRequireDefault(require("../../components/storefront/results/ResultsSectionHeader"));

var _StorefrontSectionMarker = _interopRequireDefault(require("../../components/storefront/StorefrontSectionMarker"));

var _FeaturedCollections = _interopRequireDefault(require("./FeaturedCollections"));

var LANGS = ['en', 'de', 'es', 'fr', 'ja', 'pt'];
var MIN_SECTION_HEIGHT = 360;
var getCollectionSectionResults = (0, _reselect.createSelector)([function (state) {
  return state.allCollectionsResults;
}, function (__state, collection) {
  return collection;
}], function (allCollectionsResults, collection) {
  return allCollectionsResults.get(collection);
});

var CollectionResultsSection = function CollectionResultsSection(_ref) {
  var collection = _ref.collection,
      _ref$lazy = _ref.lazy,
      lazy = _ref$lazy === void 0 ? true : _ref$lazy,
      onFetch = _ref.onFetch,
      _ref$requestState = _ref.requestState,
      requestState = _ref$requestState === void 0 ? _RequestState.UNINITIALIZED : _ref$requestState,
      trackSectionInteraction = _ref.trackSectionInteraction,
      trackSectionResultClick = _ref.trackSectionResultClick;

  var _useSelector = (0, _reactRedux.useSelector)(function (state) {
    return getCollectionSectionResults(state, collection);
  }),
      results = _useSelector.items;

  var sectionRef = (0, _react.useRef)(null);
  var visible = (0, _useVisible.useVisible)(sectionRef, MIN_SECTION_HEIGHT / 2 + "px 0px 0px 0px");
  var requestUninitialized = (0, _requestState.isUninitialized)(requestState);
  var sectionName = (0, _react.useMemo)(function () {
    var sectionModel;

    switch (collection) {
      case StorefrontCollection.POPULAR:
      case StorefrontCollection.NEW:
        {
          sectionModel = 'ranked';
          break;
        }

      default:
        {
          sectionModel = 'random';
          break;
        }
    }

    return "collection::" + collection + "::" + sectionModel;
  }, [collection]);
  var renderedResults = (0, _react.useMemo)(function () {
    if ((0, _requestState.isFailed)(requestState)) {
      return _react.default.createElement(_GenericError.default, null);
    }

    return _react.default.createElement(_ResultsGrid.default, {
      onResultClick: function onResultClick(result, index) {
        trackSectionResultClick(sectionName, result, index, {
          totalResults: results.size,
          filter: collection
        });
      },
      requestState: requestState,
      resultProps: {
        collection: collection
      },
      results: results
    });
  }, [collection, requestState, results, sectionName, trackSectionResultClick]);
  (0, _react.useEffect)(function () {
    if (requestUninitialized && (!lazy || lazy && visible)) {
      onFetch();
    }
  }, [visible, requestUninitialized, onFetch, lazy]);
  return _react.default.createElement("div", {
    ref: sectionRef
  }, _react.default.createElement(_StorefrontSectionMarker.default, {
    name: sectionName
  }), _react.default.createElement(_ResultsSection.default, {
    style: {
      minHeight: MIN_SECTION_HEIGHT
    }
  }, _react.default.createElement(_ResultsSectionHeader.default, {
    details: _react.default.createElement(_FormattedMessage.default, {
      message: (0, _i18n.getCollectionI18nKey)(collection, 'subheadingText')
    }),
    title: _react.default.createElement(_FormattedMessage.default, {
      message: (0, _i18n.getCollectionI18nKey)(collection, 'titleText')
    })
  }, _react.default.createElement(_UIRouterLink.default, {
    onClick: function onClick() {
      trackSectionInteraction(sectionName, 'click see all collection');
    },
    to: (0, _urls.getCollectionUrl)(collection)
  }, _react.default.createElement(_FormattedMessage.default, {
    message: "appMarketplace.storefront.results.allCollections.seeAllLinkText"
  }))), renderedResults));
};

var ActionTypes = {
  REQUEST_REQUESTED: 'REQUEST_REQUESTED',
  REQUEST_SUCCEEDED: 'REQUEST_SUCCEEDED',
  REQUEST_FAILED: 'REQUEST_FAILED',
  SECTION_MOUNTED: 'SECTION_MOUNTED'
};
var initialState = {
  navMarkerActive: false,
  requestStates: _immutable.default.Map(),
  sections: _immutable.default.OrderedSet()
};

var reducer = function reducer(state, action) {
  switch (action.type) {
    case ActionTypes.REQUEST_REQUESTED:
      {
        var requestStates = state.requestStates;
        var collection = action.meta.collection;
        return (0, _extends2.default)({}, state, {
          requestStates: requestStates.set(collection, _RequestState.PENDING)
        });
      }

    case ActionTypes.REQUEST_SUCCEEDED:
      {
        var _requestStates = state.requestStates;
        var _collection = action.meta.collection;
        return (0, _extends2.default)({}, state, {
          navMarkerActive: true,
          requestStates: _requestStates.set(_collection, _RequestState.SUCCEEDED)
        });
      }

    case ActionTypes.REQUEST_FAILED:
      {
        var _requestStates2 = state.requestStates;
        var _collection2 = action.meta.collection;
        return (0, _extends2.default)({}, state, {
          requestStates: _requestStates2.set(_collection2, _RequestState.FAILED)
        });
      }

    case ActionTypes.SECTION_MOUNTED:
      {
        var sections = state.sections;
        var name = action.payload.name;
        return (0, _extends2.default)({}, state, {
          sections: sections.add(name)
        });
      }

    default:
      return state;
  }
};

var AllCollections = function AllCollections(_ref2) {
  var fetchAllCollectionsCollectionResult = _ref2.fetchAllCollectionsCollectionResult,
      url = _ref2.match.url;
  var mounted = (0, _useMounted.useMounted)();
  var isPrerenderUserAgent = (0, _userAgent.getIsPrerenderUserAgent)();

  var _useReducer = (0, _react.useReducer)(reducer, initialState),
      _useReducer2 = (0, _slicedToArray2.default)(_useReducer, 2),
      state = _useReducer2[0],
      dispatch = _useReducer2[1];

  var navMarkerActive = state.navMarkerActive,
      requestStates = state.requestStates,
      sections = state.sections;
  var hasAllFulfilledRequests = (0, _react.useMemo)(function () {
    return requestStates.every(function (requestState) {
      return (0, _requestState.isFulfilled)(requestState);
    });
  }, [requestStates]);
  var getSectionWithPlacement = (0, _react.useCallback)(function (section) {
    var index = sections.valueSeq().indexOf(section);
    return (index < 10 ? "0" + index : index) + "::" + section;
  }, [sections]);

  var _useContext = (0, _react.useContext)(_StorefrontUsageTrackerContext.default),
      trackInteraction = _useContext.trackInteraction,
      trackPageView = _useContext.trackPageView,
      trackResultClick = _useContext.trackResultClick;

  var trackSectionInteraction = (0, _react.useCallback)(function (section, action) {
    trackInteraction(action, {
      section: section,
      sectionWithPlacement: getSectionWithPlacement(section)
    }, 'storefront-section-interaction');
  }, [getSectionWithPlacement, trackInteraction]);
  var trackSectionResultClick = (0, _react.useCallback)(function (section, result, resultIndex) {
    var properties = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
    trackResultClick(result, resultIndex, (0, _extends2.default)({}, properties, {
      section: section,
      sectionWithPlacement: getSectionWithPlacement(section)
    }));
  }, [getSectionWithPlacement, trackResultClick]);
  var handleSectionMount = (0, _react.useCallback)(function (name) {
    return dispatch({
      type: ActionTypes.SECTION_MOUNTED,
      payload: {
        name: name
      }
    });
  }, []);
  var renderedResults = (0, _react.useMemo)(function () {
    return _storefrontCollectionOrder.default.map(function (collection) {
      return _react.default.createElement(CollectionResultsSection, {
        key: collection,
        collection: collection,
        lazy: !(isPrerenderUserAgent || collection === StorefrontCollection.POPULAR),
        onFetch: function onFetch() {
          dispatch({
            type: ActionTypes.REQUEST_REQUESTED,
            meta: {
              collection: collection
            }
          });
          fetchAllCollectionsCollectionResult(collection).then(function () {
            dispatch({
              type: ActionTypes.REQUEST_SUCCEEDED,
              meta: {
                collection: collection
              }
            });
          }).catch(function (error) {
            dispatch({
              type: ActionTypes.REQUEST_FAILED,
              payload: error,
              meta: {
                collection: collection
              }
            });
          });
        },
        requestState: requestStates.get(collection),
        trackSectionInteraction: trackSectionInteraction,
        trackSectionResultClick: trackSectionResultClick
      });
    });
  }, [fetchAllCollectionsCollectionResult, isPrerenderUserAgent, requestStates, trackSectionInteraction, trackSectionResultClick]);
  var renderedPageMeta = (0, _react.useMemo)(function () {
    var metaDescription = (0, _unescapedText.default)((0, _i18n.getCollectionI18nKey)('all', 'metaDescription'));
    return _react.default.createElement(_auth.PublicOnly, null, _react.default.createElement(_DocumentHead.default, null, _react.default.createElement(_CanonicalLink.default, {
      to: url
    }), _react.default.createElement(_HrefLangLink.default, {
      href: (0, _urls.getLocalizedPublicUrl)('en'),
      "x-default": true
    }), LANGS.map(function (lang) {
      return _react.default.createElement(_HrefLangLink.default, {
        key: lang,
        href: (0, _urls.getLocalizedPublicUrl)(lang),
        lang: lang
      });
    }), _react.default.createElement("meta", {
      name: "description",
      content: metaDescription
    }), _react.default.createElement(_TwitterMeta.default, {
      name: "card"
    }), _react.default.createElement(_TwitterMeta.default, {
      name: "site"
    }), _react.default.createElement(_TwitterMeta.default, {
      name: "image",
      content: (0, _urls.getStorefrontScreenshotUrl)()
    }), _react.default.createElement(_OpenGraphMeta.default, {
      property: "type"
    }), _react.default.createElement(_OpenGraphMeta.default, {
      property: "title"
    }), _react.default.createElement(_OpenGraphMeta.default, {
      property: "url",
      content: (0, _history.getFullHref)(url)
    }), _react.default.createElement(_OpenGraphMeta.default, {
      property: "description",
      content: metaDescription
    }), _react.default.createElement(_OpenGraphMeta.default, {
      property: "image",
      content: (0, _urls.getStorefrontScreenshotUrl)()
    }), _react.default.createElement(_PrerenderReady.default, {
      ready: hasAllFulfilledRequests
    })));
  }, [hasAllFulfilledRequests, url]);
  (0, _react.useEffect)(function () {
    if (mounted) {
      document.title = _I18n.default.text((0, _i18n.getCollectionI18nKey)('all', 'htmlTitle'));
      var sectionsArray = sections.toArray();
      trackPageView({
        section: sectionsArray.slice().sort(),
        sectionWithPlacement: sectionsArray.map(function (section) {
          return getSectionWithPlacement(section);
        })
      });
    }
  }, [getSectionWithPlacement, mounted, sections, trackPageView]);
  return _react.default.createElement(_NavMarker.default, {
    active: navMarkerActive,
    name: "STOREFRONT_LOAD"
  }, _react.default.createElement(_StorefrontSectionMarkerContext.default.Provider, {
    value: {
      onMount: handleSectionMount
    }
  }, _react.default.createElement(_FeaturedCollections.default, {
    trackSectionInteraction: trackSectionInteraction
  }), renderedResults, renderedPageMeta));
};

AllCollections.propTypes = {
  fetchAllCollectionsCollectionResult: _propTypes.default.func.isRequired,
  match: _propTypes.default.shape({
    url: _propTypes.default.string.isRequired
  }).isRequired
};
var mapDispatchToProps = {
  fetchAllCollectionsCollectionResult: StorefrontActions.fetchAllCollectionsCollectionResult
};

var _default = (0, _reactRedux.connect)(undefined, mapDispatchToProps)(AllCollections);

exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./js/containers/storefront/AllCollections.js
// module id = 887
// module chunks = 209 210 211 212